import { Component, OnInit, Input } from '@angular/core';
import { ControlBase } from '../controls-base';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-control',
  templateUrl: './control.component.html',
  styleUrls: ['./control.component.scss']
})
export class ControlComponent implements OnInit {
  @Input() control!: ControlBase;
  @Input() form!: FormGroup;
  @Input() formMarkAsTouched!: boolean;
  @Input() selectedReceiverData: any[] = [];

  constructor() { }

  ngOnInit(): void {}

}
